import type { IComponentController, IScope } from "angular";
import { map } from "rxjs/operators";

import type { IPartnerUserSlim } from "App/Modules/Models";
import type { IPartnerUsersRepository } from "App/Modules/Repositories";

import { cloneDeep, forEach, isEmpty, isObject } from "lodash";

export default class FindAddUserComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmPartnerUsersRepository"];

    public partnerId: string;

    public newUser: (params: { searchString: string }) => void;

    public selectUser: (params: { user: IPartnerUserSlim }) => void;

    public selectedUser: IPartnerUserSlim;

    public canAddUser: boolean;

    public withSelectPrompt = false;

    public clearAfterAdd: boolean;

    public hideTitle: boolean;

    public title: string;

    public removeFromResult: string[];

    public allowEmpty: boolean;

    public initialValue: IPartnerUserSlim;

    private selectKey = "select";

    private searchString: string;

    constructor(private readonly $scope: IScope, private readonly partnerUsersRepository: IPartnerUsersRepository) {}

    public $onInit() {
        if (this.removeFromResult === undefined) {
            this.removeFromResult = [];
        }

        if (this.initialValue) {
            this.selectedUser =
                isObject(this.initialValue) && isEmpty(this.initialValue) ? null : cloneDeep(this.initialValue);
        }

        if (this.allowEmpty) {
            this.$scope.$watch("$ctrl.selectedUser", (user) => {
                if (isEmpty(user) && this.selectUser) {
                    this.selectUser(null);
                }
            });
        }
    }

    public userSearch(value: string) {
        return this.partnerUsersRepository
            .search(this.partnerId, value)
            .pipe(
                map((result) => {
                    this.searchString = value;

                    let suggested = result.data;

                    // if result in removeFromResult, remove
                    forEach(this.removeFromResult, (user: string) => {
                        const index = suggested.findIndex((x) => x.id === user);
                        if (index !== -1) {
                            suggested.splice(index, 1);
                        }
                    });

                    suggested = suggested.slice(0, 8);

                    if (this.canAddUser || this.canAddUser === undefined) {
                        suggested.push({
                            displayName: "",
                            id: null,
                        } as IPartnerUserSlim);
                    } else if (!this.canAddUser && this.withSelectPrompt && suggested.length === 0) {
                        suggested.push({
                            displayName: "",
                            id: this.selectKey,
                        } as IPartnerUserSlim);
                    }

                    return suggested;
                }),
            )
            .toPromise();
    }

    public userSelected(user: IPartnerUserSlim) {
        if (!user.id && user.id !== this.selectKey) {
            if (this.newUser) {
                this.newUser({ searchString: this.searchString });
            }
        } else if (user.id !== this.selectKey) {
            if (this.selectUser) {
                this.selectUser({ user });
            }
        }
        if (this.clearAfterAdd && user.id !== this.selectKey) {
            this.selectedUser = null;
        }
    }
}
